/* 
 * Export component file to be used on project
*/

import MenuProfileSwap from './MenuProfileSwap.js';
export default MenuProfileSwap;
